import OrderRank from './src/main';

/* istanbul ignore next */
OrderRank.install = function (Vue) {
  Vue.component(OrderRank.name, OrderRank);
};

export default OrderRank;
